<template>
  <AppDialog :is-open="isDialogOpened"
             :ok-text="$t('common.delete')"
             :ok-loading="deleteTaskPending"
             :ok-disabled="deleteTaskPending"
             :cancel-disabled="deleteTaskPending"
             data-locator="checklist-task-delete-dialog"
             @cancel="closeDialog"
             @ok="prepareDeleteTask"
  >
    <template #title>
      {{ $t('project.checklist.dialogs.ChecklistDeleteTaskDialog.title') }}
    </template>
    <template #body>
      <div v-if="isDeletionValidationEnabled">
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteTaskDialog.deletionValidationText.sentence1') }}</p>
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteTaskDialog.deletionValidationText.sentence2') }}</p>
      </div>
      <template v-else>
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteTaskDialog.text') }}</p>
      </template>
    </template>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { DELETE_TASK, REMOVE_TASK_FROM_SELECTION } from '@/store/modules/checklist/action_types'

export default {
  name: 'ChecklistDeleteTaskDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('room', ['currentRoom']),
    ...mapState('checklist', ['deleteTaskPending']),
    ...mapGetters('checklist', ['selectedTasks']),
    isDeletionValidationEnabled () {
      return this.currentRoom?.enableValidationChecklistItemDeletion
    },
    taskIsSelected () {
      return this.selectedTasks.some(task => task.id === this.task.id)
    },
    deleteTaskSuccess () {
      return this.isDeletionValidationEnabled
             ? this.$t('project.project-settings.ProjectSettingsFeatures.checklist.pendingDeletion')
             : this.$t('project.checklist.dialogs.ChecklistDeleteTaskDialog.deleteTaskSuccess')
    },
  },
  methods: {
    ...mapActions('checklist', [DELETE_TASK, REMOVE_TASK_FROM_SELECTION]),
    async prepareDeleteTask () {
      try {
        await this.DELETE_TASK({
          mnemo: this.mnemo,
          taskId: this.task.id,
        })

        if (this.taskIsSelected) {
          this.REMOVE_TASK_FROM_SELECTION(this.task)
        }

        toast.success(this.deleteTaskSuccess)

        this.$emit('onDelete')
        this.closeDialog()
      } catch (e) {
        console.error(e)
        toast.error(this.$t('project.checklist.dialogs.ChecklistDeleteTaskDialog.deleteTaskError'))
      }
    },
  },
}
</script>
